import Cookie from '@wetransfer/transfer/modules/concorde-cookie';

export const init = (cookieDomain) => {
  // Configure Cookie
  Cookie.configure({
    path: '/',
    domain: cookieDomain,
    secure: location.protocol === 'https:',
  });
};
